import React from "react";
import CircleIcon from '@mui/icons-material/Circle';



export default function TrafficlightButtonGreen() {
return(

    <CircleIcon sx={{fontSize: '170%', color: 'traffic.green' }} />
)
}